import TYPES from './types';

//define actions - should never need to use these
export function setOLI(oldi, olri) {
  return {
    type: TYPES.URL_SET_LOAN_PARAMS,
    payload: {
      obfuscatedLenderDatabaseId: Number.parseInt(oldi),
      obfuscatedLoanRecordId: Number.parseInt(olri),
    },
  };
}

export const setLoanSummaryUpsertOrDelete = (value) => ({
  type: TYPES.SET_LOAN_SUMMARY_UPSERT_OR_DELETE,
  payload: value,
});
